import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const boothassignment = {
    label: "Booth Assignment",
    pageLabel: "Booth Assignment",
    starting: true,
    url: "boothassignment",
    pageType: "history",
    formTabs: {
      allTabs: [
        {
          label: "General",
          uid: "create",
          style: { fontFamily: "verdana" }
        }
      ]
    },
    filter:[
      {
        inputType: "displaytext",
        tab:'filter',
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        label: "Select Booth",
        description: "Select Booth"
      },
      {
        inputType: "autocomplete",
        isRequired: true,
        tab:'filter',
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getBoothEle",
            fieldType: "string",
            filters: ["pageData", "BoothEle"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Select Booth",
        name: "boothno",
        description: "Enter Booth"
    },
    {
      inputType: "displaytext",
      tab:'filter',
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      label: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:'filter',
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      label: "Booth Pramukh",
      description: "Enter Booth Pramukh"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab:'filter',
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getVoterIDb",
          fieldType: "string",
          filters: ["pageData", "VoterID"]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "Booth Pramukh",
      name: "boothpramukh",
      description: "Enter Booth Pramukh"
    },
    {
      inputType: "displaytext",
      tab:'filter',
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      label: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:'filter',
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      label: "No Of Records",
      description: ""
    },
    {
      inputType: "numberonly",
      tab:'filter',
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      label: "",
      placeHolder: "Per Page",
      name: "per_page",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:'filter',
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      label: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:'filter',
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      label: "E-Volunteer",
      description: "Enter E-Volunteer"
    },
    {
      inputType: "autocompletemulti",
      isRequired: true,
      tab:'filter',
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getVoterIDe",
          fieldType: "string",
          filters: ["pageData", "VoterID"]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "E-Volunteer",
      name: "evolunteer",
      description: "Enter E-Volunteer"
    },
    ],
    form: [
        {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "Select Booth",
            description: "Select Booth"
          }, 
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getBoothEle",
                fieldType: "string",
                filters: ["pageData", "BoothEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Select Booth",
            name: "boothno",
            description: "Enter Booth"
        },
        {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "Booth Pramukh",
            description: "Enter Booth Pramukh"
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getVoterIDb",
                fieldType: "string",
                filters: ["pageData", "VoterID"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Booth Pramukh",
            name: "boothpramukh",
            description: "Enter Booth Pramukh"
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "E-Volunteer",
            description: "Enter E-Volunteer"
          },
          {
            inputType: "autocompletemulti",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getVoterIDe",
                fieldType: "string",
                filters: ["pageData", "VoterID"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "E-Volunteer",
            name: "evolunteer",
            description: "Enter E-Volunteer"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "P-Volunteer",
            description: "Enter P-Volunteer"
          },
          {
            inputType: "autocompletemulti",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getVoterIDp",
                fieldType: "string",
                filters: ["pageData", "VoterID"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "P-Volunteer",
            name: "pvolunteer",
            description: "Enter P-Volunteer"
          },
          {
            inputType: "displaytext",
            tab:'create',
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "Reporter",
            description: "Enter Reporter"
          },
          {
            inputType: "autocompletemulti",
            isRequired: true,
            tab:'create',
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getReporterEle",
                fieldType: "string",
                filters: ["pageData", "VoterID"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Reporter",
            name: "reporterb",
            description: "Enter Reporter"
          },












               

         
    ],
    history: {
      perPage: 10,
      displayColumns: [
        {
          Header: "Booth No.",
          accessor: "boothno.value",
        },
        {
          Header: "Booth Pramukh",
          accessor: "boothpramukh.value",
        },
        {
          Header: "P-Volunteer",
          accessor: "pvolunteer.value",
        },
        {
          Header: "E-Volunteer",
          accessor: "evolunteer.value",
        },
        {
          Header: "Reporter",
          accessor: "reporter.value",
        },
       
      ]
    },
  report: {
      perPage: 10,
      queryType: "mysqlQuery",
      //   groupBy: ["schedule","subschedule"],
      query: [
        {
          dialect: "mysql",
          seq: 1,
          columnHeader: [
            {
              id: "balance1",
              headerText: "trdate",
              headerFrom: "balance"
            }
          ],
          query: ""
        }
      ],
      displayColumns: [
        {
            Header: "Booth No.",
            accessor: "boothno",
          },
          {
            Header: "Booth Pramukh",
            accessor: "boothpramukh.",
          },
          {
            Header: "P-Volunteer",
            accessor: "pvolunteer",
          },
          {
            Header: "E-Volunteer",
            accessor: "evolunteer",
          },
        
      ]
    }
  }
  export default boothassignment;